import Component from '../../../scripts/utilities/component';

class SocialShare extends Component {
    componentDidMount() {
        this.socialShare = this.root.querySelector('[data-ref="share-toggle"]');

        this.bindEventListeners();
    }

    bindEventListeners() {
        this.socialShare.addEventListener('click', this.handleShareClick.bind(this), true);
    }

    handleShareClick(e) {
        e.preventDefault();
        const shareIcons = [...this.root.querySelectorAll('.at-share-btn')];
        this.root.classList.toggle('is--visible');

        shareIcons.forEach((elm) => {
            elm.setAttribute('tabindex', '0');
        });
    }
}

export default SocialShare;



// WEBPACK FOOTER //
// ./components/eng-ms-social-share/scripts/social-share.js